module.exports = __webpack_public_path__ + "img/tick.f5b77883.svg";